module.exports = __webpack_public_path__ + "static/img/banner_desktop3.b1635b9f.jpg";